<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column
            label="序号"
            align="center"
            width="80"
            prop="seq"
          ></el-table-column>
          <el-table-column prop="in_date" label="案号" width="260">
            <template slot-scope="scope">
              {{ scope.row.caseNo || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="开庭时间" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.hearingDate || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="立案时间" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.startDate || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="结束时间" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.endDate || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="案件状态" align="center" width="130">
            <template slot-scope="scope">
              {{ scope.row.caseStatus || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="原告/上诉人/申请人">
            <template slot-scope="scope">
              {{ scope.row.plainTiffFieldName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="被告/被上诉人/被申请人">
            <template slot-scope="scope">
              {{ scope.row.defendantFieldName || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :background="background"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getCasesPost } from "@/api/workplace/companyInfo";

  export default {
    name: "JudgementDocument",

    data() {
      return {
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",
            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        obj: null,
      };
    },

    methods: {
      getCasesPost(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.skip = (this.queryForm.pageNum - 1) * 20;
        getCasesPost(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getCasesPost(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getCasesPost(this.obj);
      },
    },
  };
</script>

<style scoped></style>
